import _ from 'lodash'

const checkPermission = (permissions = [], permission = '') => {
  const check = _.findIndex(permissions, (data) => data.name === permission && data.permission === true)
  return check >= 0
}

export default checkPermission
